import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import Illustration from '../../Illustration';
import avatar from '@material-ui/core/colors/grey';

import {
  CardList,
  CardListItem,
  ColumnItem,
} from '../../core';

import {
  selectCrewList,
} from '../../../store/selectors';

const styles = theme => ({
  avatar: {
    margin: '10px',
    color: '#fff',
    backgroundColor: avatar[500],
  },
});

const CrewCards = ({ classes, crew, handleSelect }) => {
  return (
    <CardList handleSelect={handleSelect}>
      {crew.length > 0 &&
        crew.map((item, i) => {
          return (
            <CardListItem key={i} item={item} handleSelect={handleSelect}>
              <ColumnItem>
                <Avatar className={classes.avatar}>
                  C
                </Avatar>
              </ColumnItem>
              <ColumnItem>
                <Typography noWrap variant="subheading">
                  {item.crewFirstName}
                </Typography>
                <Typography noWrap variant="caption">
                  {item.email}
                </Typography>
              </ColumnItem>
            </CardListItem>
          );
        })
      }
      {crew.length === 0 &&
        <Illustration
          title="Hmm, no Crew..."
          imgKey="team_amber"
          explainerText="So… someone has to do the actual work?! You’re missing your crew, even if it’s just you."
          addItemText="Let’s get them entered by clicking the “Floating Action Button” at top right."        />
      }
    </CardList>
  );
};

const mapStateToProps = (state) => ({
  crew: selectCrewList(state),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(CrewCards);



// WEBPACK FOOTER //
// ./src/components/admin/Crew/CrewCards.jsx